import useWindowSize from "@hooks/useWindowSize";

export const MOBILE_BREAKPOINT = 768;

const MOBILE_USER_AGENT_REGEX = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;

const isMobileUserAgent = (): boolean => {
  if (typeof navigator === "undefined") return false;
  return MOBILE_USER_AGENT_REGEX.test(navigator.userAgent);
};

const useIsMobile = (): boolean => {
  const { width } = useWindowSize();

  const isMobileWidth = width > 0 && width < MOBILE_BREAKPOINT;

  return isMobileUserAgent() || isMobileWidth;
};

export default useIsMobile;
